import { Children, cloneElement, FC, FunctionComponentElement, useMemo, useState, useContext, useEffect, CSSProperties, } from "react";
// 组件
import { ProDropdown, ProMenu } from "../antd";
import { MoreOutlined } from "@ant-design/icons";
// 方法
import classNames from "classnames";
import { MenuTreeChildrenEnum, SubMenuProps, MenuItemProps, } from "./interface";
import MenuTreeContext from "./menuTreeContext";
import { IBtnList } from "../ButtonGroup/buttonGroup";
import { CommonlyTypeEnum } from "../SuperTable/interface";
import { MenuProps } from "antd";

const SubMenu: FC<SubMenuProps> = props => {
  const {
    children, label, value, icon, addonAfter, level = 0, index, itemOperation, className, operation, parentIndex,
    subLabel, titleTtooltip, noData, style, collapsed, onClickItemOperation, onClickOperation, onClickAddonAfter,
  } = props;
  const context = useContext(MenuTreeContext);
  const [isOpen, setIsOpen] = useState<boolean>(!!context.openSubMenus?.includes(index || ''));
  useEffect(() => {
    setIsOpen(!!context.openSubMenus?.includes(index || ''));
  }, [context.openSubMenus]);
  const renderChildren = () => {
    let maxLength: number = 0;
    const childrenComponent = Children.map(children, child => {
      maxLength ++;
      const childElement = child as FunctionComponentElement<MenuItemProps & SubMenuProps>;
      const { displayName } = childElement.type
      /** 暂时不嵌套SubMenu，有需要后续扩展 */
      if (displayName && displayName in MenuTreeChildrenEnum) {
        if (displayName === MenuTreeChildrenEnum.MenuItem) {
          return cloneElement(childElement, {
            collapsed,
            operation: itemOperation,
            onClickOperation: onClickItemOperation,
            index: childElement.props.value,
            key: childElement.props.value,
            parentIndex: index,
            titleTtooltip,
            level: level + 1,
            ...childElement.props,
          });
        }
        if (displayName === MenuTreeChildrenEnum.SubMenu) {
          return cloneElement(childElement, {
            // titleTtooltip: hideTitle ? false : undefined,
            collapsed,
            parentIndex: index,
            index: childElement.props.value,
            key: childElement.props.value,
            level: level + 1,
            ...childElement.props,
          });
        }
      } else {
        console.error("Warning: SubMenu has a child which is not a MenuItem component")
      }
    });
    const submenuClasses = classNames('yb-menu-tree-submenu', {
      'submenu-hidden': !isOpen,
    });
    const maxHeight: string = `${40 * maxLength}px`;
    if (!childrenComponent || !childrenComponent.length) {
      return (
        <ul className={submenuClasses} style={{maxHeight: isOpen ? 40 : 0 }}>
          <div className="not-data">{noData}</div>
        </ul>
      )
    }
    return (
      <ul className={submenuClasses} style={context.animation ? {maxHeight: isOpen ? maxHeight : 0} : {height: isOpen ? 'auto' : 0 }}>
        {childrenComponent}
      </ul>
    )
  }
  /** 点击组标题 */
  const handleClickTitle = () => {
    const newOpen = !isOpen;
    context.onOpen?.(newOpen, index as string, label || children);
    context.isSelectSubMenu && context.onSelect?.(value, label, parentIndex);
  }
  /** 点击后置标签 */
  const handleClickAddonAfter = () => {
    onClickAddonAfter?.();
  }
  /** 点击操作按钮 */
  const handleClickMenuItem = (item: any) => {
    onClickOperation?.(item.key, index as string, label || children, parentIndex);
  };
  const dropdownMenu: MenuProps | undefined = useMemo(() => {
    if (Array.isArray(operation) && operation.length) {
      const menuItems: MenuProps['items'] = [];
      operation.forEach(item => {
        const operationItem: IBtnList = (typeof item === 'object') ? item : CommonlyTypeEnum[item];
        menuItems.push({
          key: operationItem.key,
          icon: operationItem.icon,
          disabled: operationItem.disabled,
          danger: operationItem.danger,
          label: operationItem.label
        });
      });
      return {
        items: menuItems,
        onClick: handleClickMenuItem,
      };
    }
  }, [operation]);
  const classess = useMemo(() => {
    return classNames('yb-menu-tree-submenu-item', className, {
      'is-open': isOpen,
      'is-active': context.selectedSubMenuKey === index,
      'is-submenu-active': context.isSelectSubMenu &&  index === context.selectedKey,
    });
  }, [isOpen, context.selectedSubMenuKey, className, context.selectedKey]);
  const titleStr = useMemo(() => {
    if (titleTtooltip) return titleTtooltip;
    if (titleTtooltip === false) return;
    if (label && typeof label === 'string') {
      if (subLabel && typeof subLabel === 'string') {
        return `${label} ${subLabel}`;
      }
      return label;
    }
  }, [label, subLabel, titleTtooltip]);
  const submenuTitleStyle: CSSProperties = useMemo(() => {
    return {
      paddingLeft: `${level ? (10 + (24 * level)) : 10}px`,
    };
  }, [level]);
  return (
    <li className={classess} style={style}>
      <div className="submenu-title" style={submenuTitleStyle}>
        <div className="submenu-title-content yb-line-ellipsis" onClick={handleClickTitle}>
          {icon}
          {
            !collapsed && (
              <div className={classNames('submenu-title-text yb-line-ellipsis', {'not-icon': !icon})} title={titleStr}>
                <span>{label}</span>
                <span className="submenu-title-text-sub">{subLabel}</span>
              </div>
            )
          }
        </div>
        {
          !collapsed && (
            <>
              {!!addonAfter && (
                <span className="submenu-title-addon-after" onClick={handleClickAddonAfter}>{addonAfter}</span>
              )}
              {
                !!dropdownMenu && (
                  <div className="menu-item-operation">
                    <ProDropdown menu={dropdownMenu} trigger={['click']}>
                      <MoreOutlined className="menu-item-operation-icon" />
                    </ProDropdown>
                  </div>
                )
              }
            </>
          )
        }
      </div>
      {!collapsed && renderChildren()}
    </li>
  );
};

SubMenu.displayName = MenuTreeChildrenEnum.SubMenu;
SubMenu.defaultProps = {
  noData: '暂无数据',
};

export default SubMenu;